import axios from 'axios'

export class BlobService {
  static downloadPdfAsBlob = async (url: string) => {
    try {
      const response = await axios.get(url, {
        responseType: 'blob',
      })
      // convert Blob type from application/octet-stream to application/pdf
      return new Blob([response.data], { type: 'application/pdf' })
    } catch (err) {
      console.error('BlobService.downloadPdfAsBlob error:', { err })
      throw err
    }
  }
}
